﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListAnfallstelleMobil extends GuiListGeneric {

    constructor() {
        super("AnfallstelleMobil");

    }

}
